import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";


const finishOrder = async (customerReference, paymentReference, paymentProvider, taxAuthorityId, productType, searchType, searchTerm) => {
    const data = {customerReference, paymentReference, paymentProvider, taxAuthorityId, productType, searchType, searchTerm};
    var response = await axios.post('taxAuthorityOrder/finish', data, {headers: authHeader()});
    return response.data.result
}


export const taxAuthOrderApi = {
    finishOrder
}
